import { InventoryItemTransitionType } from '../../shared/models/api/inventory-item.model';

export const inventoryItemTransitionTypeTranslation: Readonly<
  Record<InventoryItemTransitionType, string>
> = {
  [InventoryItemTransitionType.CREATED]: 'INVENTORY_ITEMS.TRANSITION_LOG.TYPE.CREATED',
  [InventoryItemTransitionType.ASSIGNEE_CHANGED]:
    'INVENTORY_ITEMS.TRANSITION_LOG.TYPE.ASSIGNEE_CHANGED',
  [InventoryItemTransitionType.STATUS_CHANGED]:
    'INVENTORY_ITEMS.TRANSITION_LOG.TYPE.STATUS_CHANGED',
  [InventoryItemTransitionType.LOCATION_CHANGED]:
    'INVENTORY_ITEMS.TRANSITION_LOG.TYPE.LOCATION_CHANGED',
};
